import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'
import { push } from "../Services/Analytics"

import "./Story.scss"

import dataJSON from "../../api/Story.json"

class Story extends Component {
  constructor(props) {
    super();
    this.state = {}
    this.linkDataLayer = this.linkDataLayer.bind(this);
  }
  linkDataLayer() {
    this.props.showStory(true);
    push("Read_More_Clicked", "סיפור בלי כיסוי");
  }
  render() {
    return (
      <ScrollableAnchor id="story">
        <section className="section section-story">
          <div className="padding">
            <div className="container">
              <div className="headline">
                <div className="head">
                  {dataJSON.headline}
                </div>
                <div className="desc" dangerouslySetInnerHTML={{ __html: dataJSON.desc }}>
                </div>
                <div className="button" onClick={this.linkDataLayer}>
                  <div className="button-text">
                    {dataJSON.button.text}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </ScrollableAnchor>
    );
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/Components/Story/Story.js